<app-pan-modal #splitBranchModal [topLevel]="false" [isOpen]="isVisible()" (modalClose)="isVisible.set(false)">
  <div header>Split Branch</div>

  <div body class="flex flex-col gap-2">
    <app-pan-button-group [(panRadioGroup)]="targetMode">
      <app-pan-button [panRadio]="'new'" color="primary">Create New Branch</app-pan-button>
      <app-pan-button [panRadio]="'existing'" color="primary">Select Existing Branch</app-pan-button>
    </app-pan-button-group>

    @if (targetMode() === "new") {
      <app-pan-form-control class="flex-1">
        <app-pan-floating-label>New Branch Name</app-pan-floating-label>
        <input panInput [(ngModel)]="newBranchName" placeholder="Enter branch name..." />
      </app-pan-form-control>
    } @else {
      <app-pan-form-control class="flex-1">
        <app-pan-floating-label>Target Branch</app-pan-floating-label>
        <ng-select
          [(ngModel)]="selectedBranchId"
          [items]="branchChoices()"
          [loading]="isBranchLoading()"
          [virtualScroll]="true"
          placeholder="Select branch..."
          bindLabel="name"
          bindValue="id"
          [disabled]="isBranchLoading()"
        ></ng-select>
      </app-pan-form-control>
    }

    <app-pan-form-control class="flex-1">
      <app-pan-floating-label>Locations</app-pan-floating-label>
      <ng-select
        [(ngModel)]="selectedLocationIds"
        [multiple]="true"
        [loading]="isLoading()"
        [items]="locationChoices()"
        placeholder="Select locations..."
        bindLabel="name"
        bindValue="id"
      ></ng-select>
    </app-pan-form-control>
  </div>

  <div footer class="flex gap-2">
    <button panButton panModalClose color="default">Cancel</button>

    <button panButton panModalClose color="primary" (click)="splitBranchSwal.fire()" [disabled]="!canSplit()">Split Branch</button>
  </div>
</app-pan-modal>

<swal
  #splitBranchSwal
  title="Split Branch?"
  text="This action will move the selected locations in this branch to {{ targetBranchName() }}."
  icon="warning"
  confirmButtonText="Yes, Split"
  [showCancelButton]="true"
  [focusCancel]="true"
  (confirm)="splitBranch()"
>
</swal>
